'use strict';

var App = require('app');

var RemoteControlModeSelectorView = Marionette.ItemView.extend({
    currentPos: undefined,
    maxSize: 400,
    ui: {
        container: '.remote-popover-mode-selector',
        img: '.remote-popover-mode-selector img',
        canvas: '.remote-popover-mode-selector canvas',
        modalFooter: '.modal-footer',
    },
    events: {
        'click .js-remote-mode-selector-save': function () {
            App.hideModal();
            if (this.onSelected) {
                this.onSelected(this.currentPos);
            }
        },
    },
    template: require('components/devices/templates/controller/remote_control_mode_selector'),
    initialize: function (data) {
        this.modeSelectorIdx = data.modeSelectorIdx;
        this.remoteDevice = data.remoteDevice;
        this.device = data.remoteDevice.content;
        this.ownerView = data.ownerView;
        this.onSelected = data.onSelected;
        this.currentPos = this.device.selector[this.modeSelectorIdx].currentPos;
    },
    onShow: function () {
        var self = this;
        var counter = 0;
        var myWidth = this.ui.container.width();

        var tryCenter = function () {
            var currentWidth = self.ui.container.parent().width();
            if (currentWidth < myWidth && counter < 5) {
                counter++;
                setTimeout(function () {
                    tryCenter();
                }, 1);
            } else {
                self.redraw();
            }
        };

        tryCenter();
    },

    redraw: function () {
        var size = this.size;
        size = Math.min(size, $(document).width() * 0.8);
        size = Math.min(size, $(document).height() * 0.8);

        this.ownerView.displayModeSelector(
            this.ui.img[0],
            this.ui.canvas[0],
            this.buttons,
            size / 2,
            size / 2,
            size,
            this.device,
            this.ms,
            this.currentPos
        );
    },

    onButtonClick: function (e) {
        var nr = $(e.target).data('nr');
        if (!this.ownerView.adminMode && !this.remoteDevice.allowModeSelect(undefined, nr, this.modeSelectorIdx))
            return;

        this.currentPos = nr;
        this.redraw();
    },

    onRender: function () {
        var self = this;
        var idx = this.modeSelectorIdx;
        this.ms = this.device.selector[idx];
        this.buttons = this.ownerView.createModeSelectorButtons(this.ms, this.ui.container, idx);
        $(this.buttons).on('click', function (e) {
            self.onButtonClick(e);
        });

        var size = this.maxSize;
        size = Math.min(size, $(window).width() * 0.8);
        size = Math.min(size, $(window).height() * 0.8 - 130);
        this.size = size;
        this.ui.container.css('min-height', size);
        this.ui.container.css('width', size);
        this.ui.container.parent().css('text-align', 'center');

        var container = this.ui.modalFooter;

        this.redraw();
    },
});

module.exports = RemoteControlModeSelectorView;
